import React from 'react';
import { Outlet } from 'react-router-dom';
import MainLayout from './MainLayout';

const TravelLayout = () => {
  return (
    <MainLayout>
      <Outlet />
    </MainLayout>
  );
};

export default TravelLayout;
